import React, { FC, useState, useEffect } from 'react'
import { Select } from 'hljd'
import { SelectProps } from 'hljd/types/Select'
import API from '@api/siYiTeamGroupMember'

const Option = Select.Option

interface IMemberSelectProps extends Omit<SelectProps<any>, 'value' | 'onChange'>{
  value?: number, // 选中的团队成员id
  defaultValue?: string, // 默认值
  showAll?: boolean,
  showTeam?: boolean,
  reviewedStatus?: 0 | 1 | 2,  // 审核状态 0待审核， 1: 通过  2: 未通过
  extraOptions?: IMemberProps[] // 自定义额外的选项
  onSelect?: (value: string) => void
  onMemberLoaded?: (list: IMemberProps[])=> void // 获取成员请求完成后回调
}
export interface IMemberServicePriceTipProps  {
  id: number,
  name: string
}
export interface IMemberProps {
  id: number
  merchantId?: string
  name: string
  avatar?: string
  scheduleNum?: number // 档期数
  des?: string // 个人简介
  servicePrice?: number // 服务价格
  auditStatus?: number // 0审核中，1通过，2未通过，3二次修改审核中
  servicePriceTip?: IMemberServicePriceTipProps[] // 服务价格说明
  createdAt?: number // 创建时间
  workYear?: number  // 从业年限
}
// 成员审核状态
export const MEMBER_AUDIT_STATUS = {
  'REVIEWING': 0,
  'PASSED': 1,
  'NOT_PASSED': 2,
}


const isNoValue = (props) => {
  return !('value' in props)
}
/**
 * 司仪团队成员选择，
 * 司仪团队改版中，将原有的团队成员拆开来了
 * 目前司仪团队成员选择使用该组件。(其他四大的保留原来的)
 * 后续其他四大使用时，请在注释中补充
 * @author  Ta_Mu
 * @date 2021/5/20 10:33
 */
const MemberSelect: FC<IMemberSelectProps> = (props) => {

  const { value, defaultValue, showAll, showTeam, onSelect, reviewedStatus, extraOptions, onMemberLoaded, ...rest } = props

  const [memberList, setMemberList] = useState<IMemberProps[]>([])

  useEffect(() => {
    const getMemberList = async () => {
      const { success, data } = await API.getMemberList({ status: reviewedStatus, orderPageListAll: true})
      if(success) {
        setMemberList(data.list)
        onMemberLoaded(data.list)
      }
    }
    getMemberList()
  }, [reviewedStatus])

  const [innerValue, setInnerValue] = useState<string>(isNoValue(props) ? defaultValue : undefined)

  const handleSelectChange = (value) => {
    if(!isNoValue(props)) {
      setInnerValue(value)
    }
    onSelect(value)
  }

  return (
    <Select value={value ?? innerValue} onSelect={handleSelectChange} {...rest}>
      {
        extraOptions?.map(({ id, name }) => (
          <Option key={id} value={id}>
            {name}
          </Option>
        ))
      }
      {
        showAll && <Option value="">全部</Option>
      }
      {
        memberList?.map(({ id, name }) => (
          <Option key={id} value={id}>
            {name}
          </Option>
        ))
      }
      {
        showTeam && <Option value={0}>团队</Option>
      }

    </Select>
  )
}

MemberSelect.defaultProps = {
  showAll: true,
  showTeam: false,
  extraOptions: [],
  onSelect: () => {},
  onMemberLoaded: () => {}
}

export default MemberSelect
